import { useMemo } from 'react';
import ColumnHeaderRoot from './ColumnHeaderRoot';
import ColumnHeaderCell from './ColumnHeaderCell';
import { Group } from 'react-konva';
import { ReturnTypeofSheetSectionsSelector } from '../../../selectors/sheetUiSelector';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { UseCellSelection } from '../../../hooks/useCellSelection';
import { SelectionCell } from '../../../types';
import { getColumnRootX } from '../../../helpers/gridBoundariesHelpers';
import { getColumnsCellView } from '../../../helpers/cellView/cellColumns';
import { ColumnCellView } from '../../../helpers/cellView/cellViewTypes';

interface ColumnHeaderProps
  extends ReturnTypeofSheetSectionsSelector,
    Pick<UseCellSelection, 'onCellMouseDown' | 'onActiveHeaderMouseDown'>,
    Pick<
      UseSheetTheme,
      'stroke' | 'getHeaderFill' | 'isRtl' | 'fill' | 'isDarkTheme'
    > {
  sheetId: string;
  gridWidth: number;
}
const ColumnHeader: React.FC<ColumnHeaderProps> = (props) => {
  const {
    gridWidth,
    sheetId,
    // viewport,

    colViewport,
    defaultColWidth,
    rowHeaderWidth,
    // groupBarHeight,
    colHeaderHeight,
    freezedCols,
    freezedColsSum,
    selections,
    isRtl,
    fill,
    stroke,

    zoom,

    getHeaderFill,
    onCellMouseDown,
    onActiveHeaderMouseDown,
  } = props;

  // #region render col
  const renderHeaderRoot = () => (
    <ColumnHeaderRoot
      key={`${sheetId}-header-root`}
      x={getColumnRootX(0, gridWidth, rowHeaderWidth, isRtl)} // getColumnRootX(0, gridWidth, rowHeaderWidth, isRtl)
      y={0} // groupBarHeight
      width={rowHeaderWidth}
      height={colHeaderHeight}
      fill={fill}
      stroke={stroke}
      onCellMouseDown={onCellMouseDown}
    />
  );

  const renderHeader = (params: ColumnCellView) => {
    const { ci, width, x } = params;
    const headerFill = getHeaderFill(selections, ci, SelectionCell.Column);
    return (
      <ColumnHeaderCell
        key={`${sheetId}-header-${ci}`}
        x={x}
        y={0} //groupBarHeight
        width={width}
        height={colHeaderHeight}
        index={ci}
        stroke={stroke}
        zoom={zoom}
        onCellMouseDown={onCellMouseDown}
        onActiveHeaderMouseDown={onActiveHeaderMouseDown}
        {...headerFill}
      />
    );
  };

  const Columns = useMemo(() => {
    if (colHeaderHeight <= 0) return null;

    const Columns = getColumnsCellView(props, renderHeader);

    Columns.push(renderHeaderRoot());

    return Columns;
  }, [
    // zoom,

    isRtl,
    gridWidth,
    // cols,

    colViewport,

    // defaultColWidth,
    // rowHeaderWidth,
    // colHeaderHeight,
    // freezedColsSum,
    // freezedCols,
    selections,

    props.isDarkTheme,
    // fill,
    // stroke,
    // getHeaderFill,

    onCellMouseDown,
    // onActiveHeaderMouseDown,
  ]);

  return <Group>{Columns}</Group>;

  // const freezeBarHandleSize = getFreezeBarHandleSize(freezedCols, zoom);

  // return (
  //   <>
  //     <div
  //       style={{
  //         position: 'relative',
  //         width: `${freezedColsSum + rowHeaderWidth + freezeBarHandleSize}px`,
  //         height: `${colHeaderHeight}px`,
  //         display: 'inline-block',
  //       }}
  //     >
  //       <Stage
  //         x={0}
  //         y={0}
  //         width={freezedColsSum + rowHeaderWidth + freezeBarHandleSize}
  //         height={colHeaderHeight}
  //         id="stage"
  //       >
  //         <Layer>
  //           <Group>
  //             {renderHeaderRoot(
  //               freezedColsSum + rowHeaderWidth + freezeBarHandleSize
  //             )}
  //             {renderColumnCells(
  //               freezedColsSum + rowHeaderWidth + freezeBarHandleSize,
  //               rowHeaderWidth,
  //               freezedCols.start,
  //               freezedCols.end,
  //               props,
  //               renderHeader,
  //               { isFrozen: true }
  //             )}
  //           </Group>
  //         </Layer>
  //       </Stage>
  //     </div>

  //     <div
  //       style={{
  //         position: 'relative',
  //         width: `${
  //           gridWidth - freezedColsSum - freezeBarHandleSize - rowHeaderWidth
  //         }px`,
  //         height: `${colHeaderHeight}px`,
  //         display: 'inline-block',
  //       }}
  //     >
  //       <Stage
  //         x={0}
  //         y={0}
  //         width={
  //           gridWidth - freezedColsSum - freezeBarHandleSize - rowHeaderWidth
  //         }
  //         height={colHeaderHeight}
  //         id="stage"
  //       >
  //         <Layer>
  //           <Group>
  //             {renderColumnCells(
  //               gridWidth -
  //                 freezedColsSum -
  //                 freezeBarHandleSize -
  //                 rowHeaderWidth,
  //               0,
  //               viewport.cs,
  //               viewport.ce,
  //               props,
  //               renderHeader,
  //               {
  //                 isFrozen: true,
  //               }
  //             )}
  //           </Group>
  //         </Layer>
  //       </Stage>
  //     </div>
  //   </>
  // );

  // return <Group>{Columns}</Group>;
};

export default ColumnHeader;
